<div class="modal-body">
    <cm-dynamic-form-content-details
        *ngIf="modalDetails"
        [contentDetails]="modalDetails"
    ></cm-dynamic-form-content-details>
    <cm-multiple-dynamic-form
        [previewMode]="previewMode"
        [templateFormFields]="templateFormFields"
        [dynamicForms]="dynamicForms || []"
        [sections]="sections"
    >
    </cm-multiple-dynamic-form>
    <cm-signature *ngIf="previewMode && signatureLink" class="signature-bar" [editable]="false"></cm-signature>
</div>
<div class="modal-footer">
    <button *ngIf="isResetEnabled" type="button" class="btn btn-default" (click)="onScreenChange(PAGES.RESET_CONFIRM)">
        RESET
    </button>
    <button *ngIf="!previewMode" type="button" class="btn btn-default" (click)="onScreenChange(PAGES.BACK)">
        BACK
    </button>
    <button *ngIf="!previewMode" type="button" class="btn btn-primary" (click)="saveAsDraft()">Save as Draft</button>
    <button *ngIf="!previewMode" type="button" class="btn btn-primary" (click)="onSubmitForm()">Submit</button>
    <button *ngIf="previewMode" type="button" class="btn btn-primary" (click)="dismissModal()">CLOSE</button>
</div>
